import axios from 'axios';
import { Env } from '@Constants/BuildInfo';
import AppStorage from '@Services/AppStorage';
import reduce from 'lodash/reduce';

const paramsHolder = {
  authPrefix: 'AuthUrlPrefix',
  autosuggest: 'AutosuggestUrlPrefix',
  restPrefix: 'RestUrlPrefix',
  wsPrefix: 'WSUrlPrefix',
  license: 'ChemaxonUrlPrefix',
  availability: 'AvailabilityUrlPrefix',
};

export function getUrlByParam(url, param) {
  const prefix = (AppStorage.instance.get('BEURL') || Env)[param];
  if (/^http/.test(url)) {
    return url;
  }
  return prefix + url;
}

export function generateUrlQuery(params) {
  return reduce(
    params,
    (acc, val, key) => {
      // eslint-disable-next-line prefer-template
      acc.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
      return acc;
    },
    []
  ).join('&');
}

export function getUrlWithPrefix(url, prefix) {
  // eslint-disable-next-line no-param-reassign
  prefix = prefix || 'restPrefix';
  return getUrlByParam(url, paramsHolder[prefix]);
}

/**
 * Function that provides right Marvin License according dev/prod deployment
 * @returns {string}
 */
export function getMarvinLicense(url) {
  return getUrlByParam(url, paramsHolder.license);
}

export function send(url, type, data, config) {
  if (typeof url !== 'string') {
    Logger.error('Please pass string for url Param');
    return false;
  }
  if (typeof type !== 'string') {
    Logger.error('Please pass string for type Param');
    return false;
  }

  if (type === 'GET' && data) {
    // eslint-disable-next-line no-param-reassign
    url = `${url}?${generateUrlQuery(data)}`;
  }

  const canceler = {
    promise: null,
    resolve: null,
  };

  canceler.promise = new Promise((resolve) => {
    canceler.resolve = resolve;
  });

  let params = {
    method: type.toUpperCase(),
    url,
    cache: true,
    data: data || {},
    timeout: canceler.promise,
  };

  if (config) {
    params = { ...params, ...config };
  }

  const promise = axios(params);
  promise.cancel = () => canceler.resolve();

  promise.catch((response) => {
    if (response.data) Logger.error(response.data);
    return response;
  });

  return promise;
}
